import React, { Fragment, useEffect, useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import InputComponent from "./InputTextComponent";
import { styles } from "../../style/styles";
import { useSelector } from "react-redux";
import {
  getFormattedTimeDifference,
  getStatusDelivery,
} from "../../services/Functions";
import {
  updateConfirmedStone,
  getStatusFornitureDelivery,
} from "../../services/ConnectDataBase";
import { getCurrentDateTime } from "../../services/Functions";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { COMPONENT_COLORS, STATUS_COLORS } from "../../style/colors.js";

const DynamicFlatList = ({ data, itemWidths, screenName }) => {
  const [isFirstConfirmed, setIsFirstConfirmed] = useState(false);
  const [isSecondConfirmed, setIsSecondConfirmed] = useState(false);
  const codeScan = useSelector((state) => state.infoData.infoData.MO);
  const PO = useSelector((state) => state.infoData.infoData.PO);
  const name = useSelector((state) => state.user.name);
  const confirmed = "CONFIRMED";
  let status = "";
  let ConfirmedFirstTeam = "";
  let ConfirmedSecondTeam = "";
  let codePage = "";

  if (screenName === "StoneDeliveryScreen") {
    status = "stoneStatus";
    codePage = 7;
    ConfirmedFirstTeam = "PIEDRAS";
    ConfirmedSecondTeam = "TALLER";
  } else if (screenName === "FornitureDeliveryScreen") {
    status = "fornitureStatus";
    codePage = 10;
    ConfirmedFirstTeam = "FORNITURE";
    ConfirmedSecondTeam = "TALLERFORNITURE";
  }

  useEffect(() => {
    if (screenName === "StoneDeliveryScreen") {
      getStatusDelivery(codeScan, codePage, status, PO)
        .then((estado) => {
          setIsFirstConfirmed(estado[0]);
          setIsSecondConfirmed(estado[1]);
        })
        .catch((error) => {
          console.error(error);
          setIsFirstConfirmed(false);
          setIsSecondConfirmed(false);
        });
    } else if (screenName === "FornitureDeliveryScreen") {
      getStatusForDelivery();
    }
  }, []);

  async function getStatusForDelivery() {
    try {
      const statusDelivery = await getStatusFornitureDelivery(
        codeScan,
        codePage,
        status,
        PO
      );

      if (
        statusDelivery[0]?.usuario_ok_fornituras &&
        statusDelivery[0]?.fecha_ok_fornituras
      ) {
        setIsFirstConfirmed(true);
      }
      if (
        statusDelivery[0]?.usuario_ok_fornituras_taller &&
        statusDelivery[0]?.fecha_ok_fornituras_taller
      ) {
        setIsSecondConfirmed(true);
      }
    } catch (error) {
      // Manejo de errores
      console.error(error);
    }
  }

  const renderColumns = (item, index) => {
    const addDuration = [
      "TimeAndStatusScreen",
      "TimeWorkScreen",
      "Crimping",
      "ProblemQualityScreen",
    ];

    const hasMotivo = "motivo" in item;

    if (addDuration.includes(screenName)) {
      if (item.start && item.end) {
        item.diffTime = getFormattedTimeDifference(item.start, item.end);
      }
    }

    if (screenName === "QualityReceptionScreen") {
      item.comentario = item.comentario ? item.comentario : <InputComponent />;
    }

    if (screenName === "ProblemQualityScreen" && !hasMotivo) {
      return null;
    }

    if (screenName === "TimeAndStatusScreen") {
      let iconos = "";
      let filterType = item.tipo_tiempo;
      delete item.tipo_tiempo;
      /////ICONS TYPE ////
      if (filterType === "WEIGHT") {
        iconos = (
          <MaterialCommunityIcons name='weight' size={18} color={COMPONENT_COLORS.ICON_WEIGHT} />
        );
      } else if (filterType === "TIME_WORK") {
        iconos = (
          <MaterialCommunityIcons
            name='clock-outline'
            size={18}
            color={COMPONENT_COLORS.ICON_TIME}
          />
        );
      } else if (filterType === "PROBLEM_QUALITY") {
        iconos = (
          <MaterialCommunityIcons name='alert-circle' size={18} color={STATUS_COLORS.ERROR} />
        );
      } else if (filterType === "CRIMPING") {
        iconos = <MaterialCommunityIcons name='ring' size={18} color='white' />;
      } else {
        iconos = (
          <MaterialCommunityIcons name='chart-donut' size={18} color={STATUS_COLORS.SUCCESS} />
        );
      }

      const iconElement = (
        <View key='icon' style={styles.iconContainer}>
          <Text style={{ padding: 8 }}>{iconos}</Text>
        </View>
      );

      const columns = [
        iconElement,
        ...Object.entries(item)
          .filter(
            ([key]) =>
              !(
                (screenName === "TimeAndStatusScreen" ||
                  screenName === "TimeWorkScreen" ||
                  screenName === "Crimping") &&
                key === "motivo"
              )
          )
          .map(([key, value], columnIndex) => {
            const columnWidth = itemWidths[columnIndex] || "20%";

            return (
              <Fragment key={columnIndex}>
                <View style={{ width: columnWidth }}>
                  <Text style={[styles.textList, styles.textColor]}>
                    {value}
                  </Text>
                </View>
              </Fragment>
            );
          }),
      ];
      return (
        <View
          key={index}
          style={{
            ...styles.time,
            borderColor: styles.componentColor.backgroundColor,
            textAlign: "center",
          }}>
          {columns}
        </View>
      );
    }

    return (
      <View
        key={index}
        style={{
          ...styles.time,
          borderColor: styles.componentColor.backgroundColor,
          textAlign: "center",
        }}>
        {Object.entries(item)
          .filter(
            ([key]) =>
              !(
                (screenName === "TimeAndStatusScreen" ||
                  screenName === "TimeWorkScreen" ||
                  screenName === "Crimping") &&
                key === "motivo"
              )
          )
          .map(([key, value], columnIndex) => {
            const columnWidth = itemWidths[columnIndex] || "20%";

            return (
              <Fragment key={columnIndex}>
                <View style={{ width: columnWidth }}>
                  <Text
                    style={[styles.textList, styles.textColor]}
                    adjustsFontSizeToFit>
                    {value}
                  </Text>
                </View>
              </Fragment>
            );
          })}
        {["StoneDeliveryScreen", "FornitureDeliveryScreen"].includes(
          screenName
        ) && (
          <Fragment>
            <View
              style={[
                isFirstConfirmed
                  ? styles.checkconfirmed
                  : styles.boxInfoTextStoneConfirm,
              ]}>
              <TouchableOpacity
                style={[
                  styles.InfoTextWorking,
                  isFirstConfirmed && styles.disabledButton,
                ]}
                onPress={() => handleConfirm("first")}
                disabled={isFirstConfirmed}>
                <Text style={styles.buttonTextCheckConfirmed}>
                  {isFirstConfirmed ? "Confirmado" : "Confirmar"}
                </Text>
              </TouchableOpacity>
            </View>
            <View
              style={
                isSecondConfirmed
                  ? styles.checkconfirmed
                  : styles.boxInfoTextStoneConfirm
              }>
              <TouchableOpacity
                style={[
                  styles.InfoTextWorking,
                  !isFirstConfirmed || isSecondConfirmed
                    ? styles.disabledButton
                    : null,
                ]}
                onPress={() => handleConfirm("second")}
                disabled={!isFirstConfirmed || isSecondConfirmed}>
                <Text style={styles.buttonTextCheckConfirmed}>
                  {isSecondConfirmed ? "Confirmado" : "Confirmar"}
                </Text>
              </TouchableOpacity>
            </View>
          </Fragment>
        )}
      </View>
    );
  };

  const handleConfirm = (action) => {
    // Lógica para confirmar el elemento seleccionado
    if (action === "first" && !isFirstConfirmed) {
      setIsFirstConfirmed(true);

      updateConfirmedStone(
        codeScan,
        codePage,
        ConfirmedFirstTeam,
        name,
        getCurrentDateTime(),
        confirmed,
        PO,
        screenName
      );
    } else if (action === "second" && !isSecondConfirmed) {
      setIsSecondConfirmed(true);

      updateConfirmedStone(
        codeScan,
        codePage,
        ConfirmedSecondTeam,
        name,
        getCurrentDateTime(),
        confirmed,
        PO,
        screenName
      );
    }
  };

  return <View>{data.map((item, index) => renderColumns(item, index))}</View>;
};

export default DynamicFlatList;
